// extracted by css-extract-rspack-plugin
export default {"do":"do-U1SznZ","list":"list-x73Mk2"};